module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/footer-balls-07ff6e5e76a07cf5f5aeaf9fc88df8cd.svg";